export const chartPadding = {
  left: 48,
  right: 16,
  top: 40,
  bottom: 48,
};

// VictoryAxis - yAxis
export const yAxisStyle = {
  axis: { stroke: "#D4DBE5" },
  grid: { stroke: "#EEEEEE" },
  axisLabel: {
    fontSize: 14,
    fontFamily: "Mulish",
    fontWeight: 700,
    color: "#4C515A",
    padding: 34,
  },
  tickLabels: {
    padding: 14,
    fontSize: 14,
    fontFamily: "Mulish",
    fontWeight: 600,
  },
};

// VictoryAxis - xAxis
export const xAxisStyle = {
  axis: { stroke: "#D4DBE5" },
  axisLabel: {
    fontSize: 14,
    fontFamily: "Mulish",
    fontWeight: 700,
    color: "#4C515A",
    padding: 34,
  },
  tickLabels: {
    fontSize: 14,
    fontFamily: "Mulish",
    fontWeight: 600,
  },
};
